/* eslint-disable */

//values replaced via rollup_plugins.js
const urls = {
    DWELL_TIME_URL: "<@DWELL_TIME_URL@>",
    PLACES_URL: "<@PLACES_URL@>",
    BASE_URL: "<@BASE_URL@>",
    RAIL_URL: "<@RAIL_URL@>",
    REST_URL: "<@REST_URL@>",
    SINGLESEARCH_URL: "<@SINGLESEARCH_URL@>",
    AUTH_URL: "<@AUTH_URL@>",

};

export default urls;
